/**
 * @file edit-file-round.icon.tsx
 * @description Компонент для отображения иконки изменения файла.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [classnames]
 */

import cn from 'classnames';
import { IIconProps } from '@src/types';

export const EditFileRoundIcon = ({ className, color = '#045A9A', onClick }: IIconProps) => {
    return (
        <div className={cn(className, { 'cursor-pointer': onClick })} onClick={onClick} style={{ color }}>
            <svg
                width="1.482vmin"
                height="1.5878vmin"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7 0.5C3.129 0.5 0 3.629 0 7.5C0 11.371 3.129 14.5 7 14.5C10.871 14.5 14 11.371 14 7.5C14 3.629 10.871 0.5 7 0.5ZM9.17 4.049C9.268 4.049 9.366 4.084 9.45 4.161L10.339 5.05C10.5 5.204 10.5 5.449 10.339 5.596L9.639 6.296L8.204 4.861L8.904 4.161C8.974 4.084 9.072 4.049 9.17 4.049ZM7.791 5.267L9.233 6.709L4.991 10.951H3.549V9.509L7.791 5.267Z"
                    fill="currentcolor"
                />
            </svg>
        </div>
    );
};
